export enum DateTimePickerFormatEnum {
  MODAL = 'MODAL',
  POPOVER = 'POPOVER',
}
